<template>
  <form>
    <table id="TariffCalculator" cellspacing="0">
      <thead>
        <tr>
          <th colspan="2">{{ t[lang].AREA_INFORMATION }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label for="AreaName" class="required">
              <span style="color: red">* {{ t[lang].AREA_NAME }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <select id="AreaName" name="AreaName" v-model="values.areaId">
              <option value="0">{{ t[lang].PLEASE_SELECT }}</option>

              <optgroup
                v-for="province in provinces"
                :key="province"
                :label="t[lang][province]"
              >
                <option
                  v-for="area in getAreasForProvice(province)"
                  :value="area.Id"
                  :key="area.Id"
                  >{{ area.Name }}</option
                >
              </optgroup>
            </select>
            <span class="error" v-if="isRequiredError('areaId')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
          </td>
        </tr>
      </tbody>

      <thead>
        <tr>
          <th colspan="2">{{ t[lang].VESSEL_INFORMATION }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label for="Length" class="required">
              <span style="color: red">* {{ t[lang].LENGTH }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <input
              id="Length"
              name="Length"
              type="number"
              v-model="values.vesselLength"
            />
            <span class="error" v-if="isRequiredError('vesselLength')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
            <span class="error" v-if="isFormatError('vesselLength')">
              {{ t[lang].FORMAT_ERROR }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="Breadth" class="required">
              <span style="color: red">* {{ t[lang].BREADTH }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <input
              id="Breadth"
              name="Breadth"
              type="number"
              v-model="values.vesselBreadth"
            />
            <span class="error" v-if="isRequiredError('vesselBreadth')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
            <span class="error" v-if="isFormatError('vesselBreadth')">
              {{ t[lang].FORMAT_ERROR }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="MouldedDepth" class="required">
              <span style="color: red">* {{ t[lang].MOULDED_DEPTH }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <input
              id="MouldedDepth"
              name="MouldedDepth"
              type="number"
              v-model="values.vesselDepth"
            />
            <span class="error" v-if="isRequiredError('vesselDepth')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
            <span class="error" v-if="isFormatError('vesselDepth')">
              {{ t[lang].FORMAT_ERROR }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="SizeUnits" class="required">
              <span style="color: red">* {{ t[lang].VESSE_UNITS }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <select
              name="SizeUnits"
              id="SizeUnits"
              v-model="values.vesselUnits"
            >
              <option value="F">{{ t[lang].FEET }}</option>
              <option value="M" selected="selected">{{
                t[lang].METERS
              }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label for="Grt" class="required">
              <span style="color: red"
                >* {{ t[lang].GROSS_REGISTERED_TONNAGE }}</span
              >
              <span>:</span>
            </label>
          </td>
          <td>
            <input
              id="Grt"
              name="Grt"
              type="number"
              v-model="values.vesselGrt"
            />
            <span class="error" v-if="isRequiredError('vesselGrt')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
            <span class="error" v-if="isFormatError('vesselGrt')">
              {{ t[lang].FORMAT_ERROR }}
            </span>
          </td>
        </tr>
      </tbody>

      <thead>
        <tr>
          <th colspan="2">{{ t[lang].ASSIGNMENT_INFORMATION }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label for="AssignmentType" class="required">
              <span style="color: red">* {{ t[lang].ASSIGNMENT_TYPE }}</span>
              <span>:</span>
            </label>
          </td>
          <td>
            <select
              id="AssignmentType"
              name="AssignmentType"
              v-model="values.assignmentTypeId"
            >
              <option value="0">{{ t[lang].PLEASE_SELECT }}</option>
              <option
                v-for="assignmentType in assignmentTypes"
                :value="assignmentType.Id"
                :key="assignmentType.Id"
                >{{ t[lang][assignmentType.Name] }}</option
              >
            </select>
            <span class="error" v-if="isRequiredError('assignmentTypeId')">
              {{ t[lang].REQUIRED_ERROR }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <label for="ExpectedDuration"
              >{{ t[lang].EXPECTED_DURATION }}:</label
            >
          </td>
          <td>
            <input
              id="ExpectedDuration"
              name="ExpectedDuration"
              type="number"
              v-model="values.expectedDuration"
            />
          </td>
        </tr>
        <tr>
          <td>
            <label for="ExpectedDraft">{{ t[lang].EXPECTED_DRAFT }}:</label>
          </td>
          <td>
            <input
              id="ExpectedDraft"
              name="ExpectedDraft"
              type="number"
              v-model="values.exectedDraft"
            />
          </td>
        </tr>
        <tr>
          <td>
            <label for="DraftUnits">{{ t[lang].DRAFT_UNITS }}:</label>
          </td>
          <td>
            <select
              id="DraftUnits"
              name="DraftUnits"
              v-model="values.draftUnits"
            >
              <option value="F">{{ t[lang].FEET }}</option>
              <option value="M" selected="selected">{{
                t[lang].METERS
              }}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label for="NeedPilotBoat">{{ t[lang].NEED_A_PILOT_BOAT }}:</label>
          </td>
          <td>
            <select
              name="NeedPilotBoat"
              id="NeedPilotBoat"
              v-model="values.needPilotBoat"
            >
              <option value="N">{{ t[lang].NO }}</option>
              <option value="Y" selected="selected">{{ t[lang].YES }}</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      style="border: none; color: #c7b729;"
      class="avia-button avia-icon_select-no avia-color-theme-color avia-size-small avia-position-left"
      @click.prevent="onSubmitClicked"
    >
      {{ t[lang].SUBMIT }}
    </button>

    <button
      type="button"
      style="border: none; color: #c7b729; margin-left: 1em;"
      class="avia-button avia-icon_select-no avia-color-theme-color avia-size-small avia-position-left"
      @click="onResetClicked"
    >
      {{ t[lang].RESET }}
    </button>
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import translations from '../translations'
import utils from '../utils'

export default {
  name: 'EntryFormComponent',

  props: {
    values: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      t: translations,
      requiredErrors: [],
      formatErrors: [],
    }
  },

  computed: {
    lang() {
      return window.location.href.indexOf('/fr/') >= 0 ? 'fr' : 'en'
    },

    ...mapState(['areas', 'assignmentTypes']),
    ...mapGetters(['provinces']),
  },

  methods: {
    getAreasForProvice(province) {
      return this.areas.filter(area => area.Province === province)
    },

    isRequiredError(field) {
      return this.requiredErrors.indexOf(field) >= 0
    },

    isFormatError(field) {
      return this.formatErrors.indexOf(field) >= 0
    },

    validateForm() {
      const requiredErrors = []
      const formatErrors = []

      if (this.values.areaId == 0) {
        requiredErrors.push('areaId')
      }

      if (this.values.assignmentTypeId == 0) {
        requiredErrors.push('assignmentTypeId')
      }

      if (this.values.vesselLength.trim().length === 0) {
        requiredErrors.push('vesselLength')
      } else {
        if (isNaN(this.values.vesselLength)) {
          formatErrors.push('vesselLength')
        }
      }

      if (this.values.vesselBreadth.trim().length === 0) {
        requiredErrors.push('vesselBreadth')
      } else {
        if (isNaN(this.values.vesselBreadth)) {
          formatErrors.push('vesselBreadth')
        }
      }

      if (this.values.vesselDepth.trim().length === 0) {
        requiredErrors.push('vesselDepth')
      } else {
        if (isNaN(this.values.vesselDepth)) {
          formatErrors.push('vesselDepth')
        }
      }

      if (this.values.vesselGrt.trim().length === 0) {
        requiredErrors.push('vesselGrt')
      } else {
        if (isNaN(this.values.vesselGrt)) {
          formatErrors.push('vesselGrt')
        }
      }

      this.requiredErrors = requiredErrors
      this.formatErrors = formatErrors

      utils.log('requiredErrors', requiredErrors)
      utils.log('formatErrors', formatErrors)

      return requiredErrors.length === 0 && formatErrors.length === 0
    },

    onResetClicked() {
      this.requiredErrors = []
      this.formatErrors = []
      this.$emit('reset')
    },

    onSubmitClicked() {
      if (this.validateForm()) {
        utils.log('submitting values', this.values)
        this.$emit('submit', this.values)
      }
    },
  },
}
</script>
